import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  checkIfDemoUserExist,
  demoLogin,
  loginUser,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import {
  APP_CONST,
  DemoUserExistCachedTime,
  DemoUserExistStorageKey,
} from "../../../config/const";
import LoaderCircle from "../../../assets/images/loader.webp";

const LoginModal = ({
  show,
  handleClose,
  handleModalShow,
  setShowOtpLesModal,
}) => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const isOtpRequired = useSelector(
    (state) => state?.app?.appDetails?.OTP === 0
  );
  const [isDemoUserExist, setIsDemoUserExist] = useState(false);
  const [loaders, setLoaders] = useState({
    login: false,
    demoLogin: false,
  });

  useEffect(() => {
    checkDemoUser();
  }, []);

  /**
   *
   * @param {string} keyName
   * @param {boolean} booleanValue
   */
  const updateLoaders = (keyName, booleanValue) => {
    setLoaders((p) => ({ ...p, [keyName]: booleanValue }));
  };

  const checkDemoUser = async () => {
    const cachedData =
      localStorage.getItem(DemoUserExistStorageKey) &&
      JSON.parse(localStorage.getItem(DemoUserExistStorageKey));

    if (
      cachedData &&
      Date.now() - cachedData?.saveTime <= DemoUserExistCachedTime
    ) {
      setIsDemoUserExist(cachedData?.demoUserExist === true);
      return;
    }

    const response = await checkIfDemoUserExist();
    if (response && response?.data?.error === false) {
      localStorage.setItem(
        DemoUserExistStorageKey,
        JSON.stringify({
          demoUserExist: response?.data?.data?.hasDemoUsers === true,
          saveTime: Date.now(),
        })
      );
      setIsDemoUserExist(response?.data?.data?.hasDemoUsers === true);
    }
  };

  const validateData = () => {
    const { username, password } = formData;
    const newErrors = {};
    if (!username || username === "") {
      newErrors.username = "Phone or Username can not be empty";
    }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errorData = validateData();

    if (Object.keys(errorData).length > 0) {
      setErrors(errorData);
    } else {
      updateLoaders("login", true);
      let loginData = { ...formData };
      // handleClose();
      dispatch(
        loginUser(loginData, () => {
          updateLoaders("login", false);
        })
      );
    }
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
  };

  const loginDemoUser = (e) => {
    e.preventDefault();
    updateLoaders("demoLogin", true);
    dispatch(
      demoLogin(() => {
        updateLoaders("demoLogin", false);
      })
    );
  };

  return (
    <Modal
      show={show}
      id="loginModal"
      className={"steps-canvas login-modal LoginModal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="white"
      ></Modal.Header>
      <Modal.Body>
        <div className={`login-section active`}>
          <div className="Login-rightPart LoginNewDesign">
            <Modal.Title>Log in to Your Account</Modal.Title>
            <div className="form-steps">
              <Form>
                <Form.Group className="form-floating mb-4">
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Enter Username"
                    onChange={handleChange}
                    isInvalid={!!errors.username}
                  />
                  <label htmlFor="formBasicName">
                    Enter Phone Number or Username
                  </label>
                  <Form.Control.Feedback type="invalid">
                    {errors?.username}
                  </Form.Control.Feedback>

                  <div className="phonenumberex">E.g. 919878987898</div>
                </Form.Group>

                <Form.Group className="form-floating mb-4">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Password*"
                    name="password"
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                  />
                  <label htmlFor="formBasicName1">Password</label>
                  <span
                    className="icon"
                    onClick={() => setShowPassword((s) => !s)}
                  >
                    {showPassword ? <IoIosEyeOff /> : <IoIosEye />}
                  </span>
                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: "block" }}
                  >
                    {errors?.password}
                  </Form.Control.Feedback>
                </Form.Group>

                {isOtpRequired && (
                  <div className="d-flex justify-content-start mb-3">
                    <a
                      className="form-link"
                      onClick={() => {
                        // setChangeModalContent((prev) => !prev);
                        handleClose();
                        handleModalShow(APP_CONST.AUTH_MODAL.FORGOT_PASSWORD);
                      }}
                    >
                      Forgot password?
                    </a>
                  </div>
                )}
                <Button
                  variant="primary"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={loaders?.login}
                >
                  {loaders?.login ? "Loading..." : "Log in"}
                </Button>
                <p>
                  Don't have an account ?{" "}
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                    }}
                  >
                    Sign up
                  </a>
                </p>
              </Form>
              {!isDemoUserExist ? (
                <img src={LoaderCircle} style={{ width: "40px" }} />
              ) : (
                isDemoUserExist && (
                  <>
                    <div className="mb-1 Demologin">
                      Need Demo? Just Click the button below.
                    </div>
                    <div
                      className="demo-login mt-1 btn btn-primary"
                      onClick={loginDemoUser}
                      disabled={loaders?.demoLogin}
                    >
                      {loaders?.demoLogin ? (
                        <img src={LoaderCircle} style={{ width: "30px" }} />
                      ) : (
                        "Demo Login"
                      )}
                    </div>
                  </>
                )
              )}

              <div className="sportsSection">
                {/* <img src={MumbaiSports} /> */}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default LoginModal;
